<template>
  <v-app>
    <v-container>
      <v-row>
        <!-- Sidebar com as conversas -->
        <v-col cols="4" class="sidebar">
          <v-list>
            <!-- Conversa 1 -->
            <v-list-item>
              <v-avatar>
                <img src="https://i.pravatar.cc/40" alt="Avatar" />
              </v-avatar>
              <v-list-item-content>
                <v-list-item-title>Regy Sabor de Pizza</v-list-item-title>
                <v-list-item-subtitle>11:01</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <!-- Conversa 2 -->
            <v-list-item>
              <v-avatar>
                <img src="https://i.pravatar.cc/40" alt="Avatar" />
              </v-avatar>
              <v-list-item-content>
                <v-list-item-title>Tio Luiz</v-list-item-title>
                <v-list-item-subtitle>06:51</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <!-- Adicione mais conversas -->
          </v-list>
        </v-col>

        <!-- Janela de Conversa -->
        <v-col cols="8" class="chat-window">
          <div class="chat-header">
            <v-avatar>
              <img src="https://i.pravatar.cc/40" alt="Avatar" />
            </v-avatar>
            <span>Bruno Oliveira</span>
          </div>
          <div class="chat-messages">
            <div class="message sent">Fala Marcelo, tô em Pombal sim! Valeu velhão! ❤️</div>
            <div class="message received">
              Feliz aniversário, que seus projetos sejam realizados...
            </div>
            <!-- Adicione mais mensagens -->
          </div>
          <div class="chat-input">
            <v-text-field label="Mensagem" dense outlined></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "WhatsAppLayout",
};
</script>

<style scoped>
.sidebar {
  background-color: #f1f1f1;
  border-right: 1px solid #ddd;
  height: 100vh;
}

.chat-window {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.chat-header {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  background-color: #e5ddd5;
}

.message {
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 8px;
}

.message.sent {
  background-color: #dcf8c6;
  align-self: flex-end;
}

.message.received {
  background-color: white;
  align-self: flex-start;
}

.chat-input {
  padding: 10px;
  border-top: 1px solid #ddd;
}
</style>
